import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tenant-management",
  "use": "icon-tenant-management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tenant-management\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 396.8c-89.6 0-160-70.4-160-160S422.4 76.8 512 76.8s160 70.4 160 160S601.6 396.8 512 396.8z m0-256c-51.2 0-96 44.8-96 96S460.8 332.8 512 332.8s96-44.8 96-96S563.2 140.8 512 140.8zM224 883.2c-51.2 0-96-44.8-96-96v-64c0-51.2 44.8-96 96-96H576v-64H224C134.4 563.2 64 633.6 64 716.8v64c0 89.6 70.4 160 160 160H576v-64H224z\" p-id=\"34494\" /><path d=\"M448 716.8h128v64H448zM864 499.2h-128c-51.2 0-96 44.8-96 96v256c0 51.2 44.8 96 96 96h128c51.2 0 96-44.8 96-96v-256c0-57.6-44.8-96-96-96z m32 345.6c0 19.2-12.8 32-32 32h-128c-19.2 0-32-12.8-32-32v-32h192v32z m0-89.6h-192v-64h192v64z m0-128h-192v-38.4c0-19.2 12.8-32 32-32h128c19.2 6.4 32 19.2 32 32v38.4z\" p-id=\"34495\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tenant-management.svg
// module id = waHO
// module chunks = 0